import { Component, Injector, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    standalone: false,
    selector: 'ep-dynamic-modal-content',
    styleUrls: ['../controls/unity-button/unity-button.component.scss'],
    template: `
    <button unity-button
      *ngIf="showCloseButton"
      type="button"
      class="close dynamic-modal-close"
      classes="icon-only icon-only-large on_dark"
      aria-label="Close"
      (click)="activeModal.dismiss('Close Button')"
    >
      <svg class="unity-icon unity-icon-times">
        <use xlink:href="#unity-icon-times"></use>
      </svg>
    </button>
    <ep-dynamic-content [type]="type" [dynamicData]="dynamicData"></ep-dynamic-content>
    <div *ngIf="showOKButton" class="modal-footer">
      <button class="primary unity-button" type="button" (click)="activeModal.dismiss('Close Button')">OK</button>
    </div>
  `
})
export class DynamicContentModalComponent {
    @Input()
    type: string;

    @Input()
    dynamicData: any;

    @Input()
    injector: Injector;

    @Input()
    showCloseButton: boolean = true;

    @Input()
    showOKButton: boolean = false;

    constructor(public activeModal: NgbActiveModal) { }
}
